import { css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { TmElement, token } from '@thiememeulenhoff/lit-sdk';
import { tagName } from '../../helpers';

const tag = tagName('tile');

@customElement(tag)
export class TileComponent extends TmElement {
  static override styles = [
    css`
      :host {
        border: theme-var(border, rem(1) solid ${token('tile-border-default')});
        border-radius: theme-var(border-radius, radius('medium'));
        display: theme-var(display, block);
        padding: theme-var(padding, rem(32));
      }
    `,
  ];

  override render() {
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'a-tile': TileComponent;
  }
}
